import { render, staticRenderFns } from "./nshop-order-view-pins.vue?vue&type=template&id=2ec22370&scoped=true&"
import script from "./nshop-order-view-pins.vue?vue&type=script&lang=js&"
export * from "./nshop-order-view-pins.vue?vue&type=script&lang=js&"
import style0 from "./nshop-order-view-pins.vue?vue&type=style&index=0&id=2ec22370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec22370",
  null
  
)

export default component.exports